<template>
  <div>
    <fieldset v-bind:disabled="isFormDisabled">
      <div>
        <div class="form-group col-md-12 mt-4">
          <floating-field type="text" id="locationName" label="name" v-model="location.name" :isRequired="true" invalidFeedback="please input location name"></floating-field>
        </div>
        <div class="form-group row mt-4">
          <input type="checkbox" class="form-control col-md-1 my-auto" style="margin-left:-15px" v-model="location.status" />
          <label class="col-md-4 mr-0 mt-2">{{ location.status | toStatusDescription }}</label>
        </div>
        <div class="form-group row mt-4">
          <input type="checkbox" class="form-control col-md-1 my-auto" style="margin-left:-15px" v-model="location.isTerminal" />
          <label class="col-md-4 mr-0 mt-2">{{ location.isTerminal ? 'Is a terminal location' : 'Not a terminal location' }}</label>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<style scoped lang="scss">
  fieldset {
    border: 0;
  }
</style>

<script>

  import { toStatusDescription } from '@/filters/enum'
  import FloatingField from '@/components/ui/FloatingField'

  export default {
    name: 'location-data-entry',
    components: {
      FloatingField
    },
    props: {
      location: {
        type: Object,
        required: true,
      },
      isFormDisabled: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    filters: {
      toStatusDescription
    }
  }
</script>
